import doc                 from '@widesk-core/decorators/doc';
import model               from '@widesk-core/decorators/model';
import AccountServiceModel from '@/models/AccountServiceModel';
import TimestampAble       from '@widesk-core/models/traits/TimestampAble';
import Blamable            from '@/models/traits/Blamable';

export enum SubscriptionStatusId {
	enabled = '1',
	disabled = '2',
}

@model.cacheDuration()
@model.urnResource('subscription_status')
@doc.path('/subscription_statuses/{?id}')
export default class SubscriptionStatusModel extends Blamable(TimestampAble(AccountServiceModel)) {
	private declare _tsFilters: {
		'reference': Account_SubscriptionStatusReference;
		'subscriptionStatusHistories': id;
		'subscriptions': id;
	};

	private declare _tsSorts: {
		'id': string;
		'label': string;
	};	

	@doc.string declare label: string;
	@doc.string declare reference: Account_SubscriptionStatusReference;

	public get color() {
		switch (this.reference) {
			case 'enabled':
				return 'green';
			case 'disabled':
				return 'orange';
			default:
				return 'default';
		}
	}
}